exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-load-wrapper{line-height:50px;text-align:center;padding:10px 0}.top-load-wrapper svg{fill:var(--light-black)}.icon-arrow{transition:.2s;transform:rotate(180deg)}.icon-loading{transform:rotate(0deg);animation-name:loading;animation-duration:3s;animation-iteration-count:infinite;animation-direction:alternate}@keyframes loading{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
